import { Checkbox, FormControl, Input, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";

const Root = styled("div")(({ theme }) => ({
  margin: theme.spacing(2),
  minWidth: 200,
  maxWidth: 300,
}));

const MenuProps = {
  slotProps: {
    paper: {
      style: {
        maxHeight: 500,
      },
    },
  },
};
interface MultiSelectProps {
  options: string[];
  selected: string[];
  setOptions: (selections: string[]) => void;
  optionLabels?: (option: string) => string;
  name: string;
}

const MultiSelect: React.FC<MultiSelectProps> = ({
  options,
  selected,
  setOptions,
  name,
  optionLabels,
}: MultiSelectProps) => {
  const handleChange = (event: SelectChangeEvent<string[]>) => {
    setOptions(event.target.value as string[]);
  };

  const label = (option: string) => (optionLabels ? optionLabels(option) : option);

  return (
    <Root>
      <FormControl variant="standard" fullWidth sx={{ minWidth: 200 }}>
        <InputLabel>{name}</InputLabel>
        <Select
          name={name}
          value={selected}
          multiple
          onChange={handleChange}
          input={<Input />}
          MenuProps={MenuProps}
          renderValue={(value) => {
            if (value.length === 1) {
              return label(value[0]);
            }
            if (value.length > 1) {
              return "Multiple selected";
            }
            return "";
          }}
          variant="standard"
        >
          {options.map((opt) => (
            <MenuItem key={opt} value={opt}>
              <Checkbox checked={selected.indexOf(opt) > -1} />
              {label(opt)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Root>
  );
};

export default MultiSelect;
